import { axiosJWT } from 'modules/axios'
import { APP_CONFIG } from 'services/app-config'

export function findIsOrderPonr(orderId) {
  return axiosJWT({
    method: 'GET',
    url: `${APP_CONFIG.care_cluster}/orders/${orderId}/ponr`,
  }).then(resp => resp.data.ponr)
}
